import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles, useTheme } from '@material-ui/styles';
import clsx from 'clsx';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Button,
  Box,
  Typography,
  Tooltip,
  CircularProgress,
  useMediaQuery
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SaveMessage from 'views/UserMessaging/customModalContent/saveMessage';
import JsonEditor from 'components/JsonEditor';
import SaveFailedMessage from 'views/UserMessaging/customModalContent/saveFailedMessage';

const useStyles = makeStyles(() => ({
  root: {},
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    width: '95%'
  },
  closeIcon: {
    margin: '5px',
    cursor: 'pointer'
  },
  cardActions: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    backgroundColor: '#F8F8F8',
    border: '1px solid #E7E7E7',
    padding: '20px',

    height: '60px'
  },
  footer: {
    position: 'fixed',
    left: '0',
    bottom: '0',
    width: '100%'
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    margin: '20%'
  }
}));

const Design = props => {
  const { className, staticContext, schema, back, showNav, ...rest } = props;

  const isSchemaSaved = useSelector(
    store => store.enrichedSchema.isSchemaSaved
  );
  const schemaDetails = useSelector(
    store => store.enrichedSchema.currentDetails
  );
  const schemaSaveFailed = useSelector(
    store => store.enrichedSchema.schemaSaveFailed
  );
  const schemaSaveFailedMessage = useSelector(
    store => store.enrichedSchema.schemaSaveFailedMessage
  );

  const {
    goBack,
    schemaObject,
    getCurrentSchemaKeys,
    isLoading,
    closeSchema,
    saveSchema,
    navBackOnError,
    updateCurrentErrorValidationSegment
  } = schema;

  const classes = useStyles();
  const { enrichedSchemaId } = useParams();
  const theme = useTheme();
  const isSideBarDisplayed = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  useEffect(() => {
    if (!schemaDetails.hasMovedToNextStep) {
      getCurrentSchemaKeys();
    }
    if (!enrichedSchemaId) {
      navBackOnError(back);
    }
    updateCurrentErrorValidationSegment('design');
  }, []);

  return (
    <div className={classes.root}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <form autoComplete="off">
          <div className={classes.headerContainer}>
            <div className={classes.title}>
              <CardHeader
                title="Enriched Schema Editor"
                titleTypographyProps={{ variant: 'h1' }}
              />
            </div>
            <div className={classes.closeIcon}>
              <Tooltip title="Close" arrow>
                <CloseIcon
                  style={{ marginTop: '16px' }}
                  onClick={closeSchema}
                  color="error"
                />
              </Tooltip>
            </div>
          </div>
          <Divider />
          <PerfectScrollbar>
            <CardContent>
              {(isLoading || !schemaObject) && (
                <div className={classes.loader}>
                  <CircularProgress />
                </div>
              )}
              {!isLoading &&
                schemaObject &&
                Object.keys(schemaObject).length > 0 && (
                  <JsonEditor schema={schema}></JsonEditor>
                )}
            </CardContent>
            {(back || showNav) && (
              <>
                <Divider />
                <div className={classes.footer}>
                  <CardActions
                    style={{
                      marginLeft: isSideBarDisplayed && '240px',
                      paddingLeft: '32px',
                      paddingRight: '32px'
                    }}
                    className={classes.cardActions}>
                    {!enrichedSchemaId && (
                      <Button
                        color="secondary"
                        variant="contained"
                        disabled={isLoading}
                        link={back}
                        onClick={goBack}>
                        Back
                      </Button>
                    )}
                    <Typography></Typography>
                    <Box flexGrow={1}>&nbsp;</Box>
                    <Button
                      color="primary"
                      variant="contained"
                      disabled={isLoading}
                      onClick={saveSchema}>
                      Save Enriched Schema
                    </Button>
                  </CardActions>
                </div>
              </>
            )}
          </PerfectScrollbar>
        </form>
      </Card>
      <SaveMessage openSnackbar={isSchemaSaved} />
      <SaveFailedMessage
        openSnackbar={schemaSaveFailed}
        message={schemaSaveFailedMessage}
      />
    </div>
  );
};

export default Design;
